var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-top",on:{"click":function($event){$event.preventDefault();_vm.scrollToTop($event)}}},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/images/icons/pagetop.svg"),"alt":"ページトップ"}}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("ページトップへ戻る")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-709d641a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/button/BtnPagetop.vue
// module id = null
// module chunks = 